import {Component, HostListener, OnInit} from '@angular/core';
import { Organization } from '../../model/organization';
import { OrganizationsService } from '../../services/organizations.service';
import { BasicFilters } from '../../model/filters/basic-filters';
import { SortOrder } from '../../model/sort-order';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslocoService} from '@ngneat/transloco';
import {CommonMessagesService} from '../../services/common-messages.service';
import { TenantsService } from '../../services/tenants.service';
import { AuthGuard } from '../../common/auth-guard.service';
import { Tenant } from '../../model/tenant';
import {FiltersService} from '../../services/filters.service';
import {LoggedUser} from '../../common/logged-user.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit {

  public organizations: Organization[];
  public totalOrganizations: number;
  public loadingOrganizations: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: BasicFilters;
  public filtersFilled: boolean;

  public confirmationVisible: boolean;
  public organizationToDelete: Organization;

  constructor(private organizationsService: OrganizationsService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              public tenantsService: TenantsService,
              public authGuardService: AuthGuard,
              private confirmationService: ConfirmationService,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<BasicFilters>,
              public loggedUser: LoggedUser) {
    this.currentFilters = new BasicFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.organizations = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadOrganizations(offset?: number, limit?: number): void {
    this.loadingOrganizations = true;
    this.organizations = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.organizationsService.getOrganizations(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.organizations = response.organizations;
        this.totalOrganizations = response.totalElements;
        this.loadingOrganizations = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadOrganizations(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new BasicFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadOrganizations(this.first / this.rows, this.rows);
  }

  showDeleteTenantConfirmation(): void {
    this.confirmationVisible = true;
  }

  confirmAndDelete(organization: Organization): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.organizationToDelete = organization;
      this.showDeleteTenantConfirmation();
      //this.deleteOrganization(organization.uuid);
    });
  }

  deleteOrganization(organizationUuid: string): void {
    this.organizationsService.deleteOrganization(organizationUuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadOrganizations(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const uuids = this.selected.map(item => item.uuid);

    this.organizationsService.deleteOrganizations(uuids).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadOrganizations(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: BasicFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
